import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Companies Redux States
import {
  GET_COMPANIES,
  GET_COMPANY,
  CREATE_COMPANY,
  EDIT_COMPANY,
  ACTIVATE_COMPANY,
  CLEAN_QUEUE,
} from "./actionTypes";
import {
  setCompanies,
  apiError,
  setCompany,
  createCompanySuccess,
  editCompanySuccess,
  activateCompanySuccess,
  cleanQueueSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getCompanies({ payload: { page, qnt, name, email, document } }) {
  try {
    const response = yield call(
      axios.get,
      `/client?${
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (email ? `&email=${email}` : "") +
        (document ? `&document=${document}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setCompanies(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createCompany({ payload: { newCompanyValues } }) {
  try {
    const response = yield call(axios.post, "/client", newCompanyValues);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(createCompanySuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getCompany({ payload: { idCompany, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/client?${
        (idCompany ? `&id=${idCompany}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setCompany(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* editCompany({ payload: { idCompany, newCompanyValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/client?${idCompany ? `&id=${idCompany}` : ""}`,
      newCompanyValues
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editCompanySuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* activateCompany({ payload: { idCompany, active } }) {
  try {
    const response = yield call(
      axios.patch,
      `/client/activate?${idCompany ? `&id=${idCompany}` : ""}`,
      active
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(activateCompanySuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* cleanQueue({ payload: { client_id, skill_id } }) {
  try {
    const response = yield call(
      axios.patch,
      `/clean-queue-client`, 
      { client_id, skill_id },
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data?.total_removed || 0;
      yield put(cleanQueueSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchCompany() {
  yield takeEvery(GET_COMPANIES, getCompanies);
}
export function* watchCreateCompany() {
  yield takeEvery(CREATE_COMPANY, createCompany);
}
export function* watchGetCompany() {
  yield takeEvery(GET_COMPANY, getCompany);
}
export function* watchEditCompany() {
  yield takeEvery(EDIT_COMPANY, editCompany);
}
export function* watchActivateCompany() {
  yield takeEvery(ACTIVATE_COMPANY, activateCompany);
}
export function* watchCleanQueue() {
  yield takeEvery(CLEAN_QUEUE, cleanQueue);
}
function* authSaga() {
  yield all([
    fork(watchCompany),
    fork(watchGetCompany),
    fork(watchCreateCompany),
    fork(watchEditCompany),
    fork(watchActivateCompany),
    fork(watchCleanQueue),
  ]);
}

export default authSaga;
